/**
 * How an employee-size range is bounded in the rubric JSON. Mirrors the API's
 * `NumericValueType`; a range the LinkedIn buckets produce is BETWEEN, or
 * GREATER_THAN for the open-ended top bucket (PREC-4055 moved it out of the
 * numeric editor component so the schema does not import a component).
 */
export enum NumericValueType {
	BETWEEN = "BETWEEN",
	GREATER_THAN = "GREATER_THAN",
	LESS_THAN = "LESS_THAN",
	NOT_BETWEEN = "NOT_BETWEEN",
}
